import { render, staticRenderFns } from "./PricingBonuses.vue?vue&type=template&id=491e3920&scoped=true"
import script from "./PricingBonuses.vue?vue&type=script&lang=js"
export * from "./PricingBonuses.vue?vue&type=script&lang=js"
import style0 from "./PricingBonuses.vue?vue&type=style&index=0&id=491e3920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491e3920",
  null
  
)

export default component.exports